import { HubConnectionState } from "@microsoft/signalr";
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../..";
import {
  UtilizationEventCorrectedSocketDto,
  UtilizationEventSplittedSocketDto,
} from "../../../services/sockets/hub-services/utilization/utilizationEventsAllService";

export interface UtilizationEventsState {
  connectionStatus: HubConnectionState;
}

export const initialState: UtilizationEventsState = {
  connectionStatus: HubConnectionState.Disconnected,
};

export const utilizationEventsSlice = createSlice({
  name: "sockets",
  initialState,
  reducers: {
    utilizationEventsConnectionStatusChanged: (
      state,
      action: PayloadAction<HubConnectionState>
    ) => {
      state.connectionStatus = action.payload;
    },
    utilizationEventCorrectedSocketEvent: (
      state,
      action: PayloadAction<UtilizationEventCorrectedSocketDto>
    ) => {},
    utilizationEventSplittedSocketEvent: (
      state,
      action: PayloadAction<UtilizationEventSplittedSocketDto>
    ) => {},
  },
});

export const {
  utilizationEventsConnectionStatusChanged,
  utilizationEventCorrectedSocketEvent,
  utilizationEventSplittedSocketEvent,
} = utilizationEventsSlice.actions;

export const selectUtilizationEventsConnectionStatus = createSelector(
  (state: RootState) =>
    state.sockets.utilization.utilizationEvents.connectionStatus,
  (connectionStatus) => connectionStatus
);

export default utilizationEventsSlice.reducer;
